import { CALL_API } from '../middleware/ApiMiddleware';

export const VIOLATION_DISPOSITION_FETCH_REQUEST = 'VIOLATION_DISPOSITION_FETCH_REQUEST';
export const VIOLATION_DISPOSITION_FETCH_SUCCESS = 'VIOLATION_DISPOSITION_FETCH_SUCCESS';
export const VIOLATION_DISPOSITION_FETCH_FAILURE = 'VIOLATION_DISPOSITION_FETCH_FAILURE';

export const VIOLATION_DISPOSITIONS_FETCH_REQUEST = 'VIOLATION_DISPOSITIONS_FETCH_REQUEST';
export const VIOLATION_DISPOSITIONS_FETCH_SUCCESS = 'VIOLATION_DISPOSITIONS_FETCH_SUCCESS';
export const VIOLATION_DISPOSITIONS_FETCH_FAILURE = 'VIOLATION_DISPOSITIONS_FETCH_FAILURE';

export const VIOLATION_DISPOSITION_CREATE_REQUEST = 'VIOLATION_DISPOSITION_CREATE_REQUEST';
export const VIOLATION_DISPOSITION_CREATE_SUCCESS = 'VIOLATION_DISPOSITION_CREATE_SUCCESS';
export const VIOLATION_DISPOSITION_CREATE_FAILURE = 'VIOLATION_DISPOSITION_CREATE_FAILURE';

export const VIOLATION_DISPOSITION_EDIT_REQUEST = 'VIOLATION_DISPOSITION_EDIT_REQUEST';
export const VIOLATION_DISPOSITION_EDIT_SUCCESS = 'VIOLATION_DISPOSITION_EDIT_SUCCESS';
export const VIOLATION_DISPOSITION_EDIT_FAILURE = 'VIOLATION_DISPOSITION_EDIT_FAILURE';

export const VIOLATION_DISPOSITION_EDIT_SEQUENCE_REQUEST = 'VIOLATION_DISPOSITION_EDIT_SEQUENCE_REQUEST';
export const VIOLATION_DISPOSITION_EDIT_SEQUENCE_SUCCESS = 'VIOLATION_DISPOSITION_EDIT_SEQUENCE_SUCCESS';
export const VIOLATION_DISPOSITION_EDIT_SEQUENCE_FAILURE = 'VIOLATION_DISPOSITION_EDIT_SEQUENCE_FAILURE';

const baseURL = 'xerce/config/dispositions';

export const fetchViolationDispositions = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [
      VIOLATION_DISPOSITIONS_FETCH_REQUEST,
      VIOLATION_DISPOSITIONS_FETCH_SUCCESS,
      VIOLATION_DISPOSITIONS_FETCH_FAILURE,
    ],
  },
});

export const createViolationDisposition = (violationDisposition: IConfigViolationDispositionRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    authenticated: true,
    body: violationDisposition,
    types: [
      VIOLATION_DISPOSITION_CREATE_REQUEST,
      VIOLATION_DISPOSITION_CREATE_SUCCESS,
      VIOLATION_DISPOSITION_CREATE_FAILURE,
    ],
  },
});

export const editViolationDisposition = (
  violationDispositionId: number,
  violationDisposition: IConfigViolationDispositionRequest
) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${violationDispositionId}`,
    method: 'put',
    authenticated: true,
    body: violationDisposition,
    types: [VIOLATION_DISPOSITION_EDIT_REQUEST, VIOLATION_DISPOSITION_EDIT_SUCCESS, VIOLATION_DISPOSITION_EDIT_FAILURE],
  },
});

export const fetchViolationDisposition = (violationDispositionId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${violationDispositionId}`,
    method: 'get',
    authenticated: true,
    types: [
      VIOLATION_DISPOSITION_FETCH_REQUEST,
      VIOLATION_DISPOSITION_FETCH_SUCCESS,
      VIOLATION_DISPOSITION_FETCH_FAILURE,
    ],
  },
});

export const editViolationDispositionSequence = (
  sequence: number[],
  params: IConfigViolationDispositionListingParams
) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    authenticated: true,
    body: { sequence },
    params,
    types: [
      VIOLATION_DISPOSITION_EDIT_SEQUENCE_REQUEST,
      VIOLATION_DISPOSITION_EDIT_SEQUENCE_SUCCESS,
      VIOLATION_DISPOSITION_EDIT_SEQUENCE_FAILURE,
    ],
  },
});
